import { render } from "./edit-bannar.vue?vue&type=template&id=7ab08fac"
import script from "./edit-bannar.vue?vue&type=script&lang=js"
export * from "./edit-bannar.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/dragger/editModel/edit-bannar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ab08fac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ab08fac', __exports__)) {
    console.log('reload')
    api.reload('7ab08fac', __exports__)
  }
  
  module.hot.accept("./edit-bannar.vue?vue&type=template&id=7ab08fac", () => {
    console.log('re-render')
    api.rerender('7ab08fac', render)
  })

}


export default __exports__